import { Component, Input, OnInit } from '@angular/core';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationPluginService } from '../../../services/reservation-plugin.service';
import { TicketReservationService } from '../../../services/ticket-reservation.service';
import { TimeService } from '../../../services/time.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { IpService } from '../../../services/ip.service';
import { ReservationQuestionAnswer } from 'projects/qcloud-models/reservation/reservation-question-answer';
import { ReservationQuestion } from 'projects/qcloud-models/reservation/reservation-questions';
import { ReservationQuestionType } from 'projects/qcloud-models/reservation/reservation-question-type.enum';

@Component({
  selector: 'app-submit-reservation',
  templateUrl: './submit-reservation.component.html',
  styleUrls: ['./submit-reservation.component.scss']
})
export class SubmitReservationComponent implements OnInit {

  @Input() formInvalid: boolean;
  @Input() categoryName: string;
  @Input() termsChecked: boolean;
  @Input() reservationInfo: ReservationPluginInfo;
  ticketReservation = new TicketReservationPlugin();
  displayReservationTime: Date;
  formSubmitted: boolean;
  ipAddress: string;

  constructor(private service: ReservationPluginService, private ticketReservationService: TicketReservationService,
    private timeService: TimeService, private recaptchaV3Service: ReCaptchaV3Service, private toastr: ToastrService,
    private translate: TranslateService, private ipService: IpService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
      // console.log();
      if (this.ticketReservation.reservationTime) {
        this.displayReservationTime = new Date(this.ticketReservation.reservationTime.getFullYear(),
          this.ticketReservation.reservationTime.getMonth(), this.ticketReservation.reservationTime.getDate(),
          this.ticketReservation.reservationTime.getUTCHours(), this.ticketReservation.reservationTime.getMinutes());
      }
    });
  }

  ngOnInit(): void {
    this.getIP();
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  makeReservation() {
    this.formSubmitted = true;
    if (this.reservationInfo.configuration.isRecaptcha) {
      this.recaptchaV3Service.execute('createReservation')
        .subscribe((token) => {
          this.createReservation(token);
        });
    }
    else {
      this.createReservation(null);
    }
  }

  createReservation(token: string) {
    this.ticketReservation.sendMailOnReservation = this.reservationInfo.configuration.sendReservationEmail;
    this.ticketReservation.sendSmsOnReservation = this.reservationInfo.configuration.sendReservationSms;
    this.ticketReservation.captchaToken = token;
    let ipQuestion = new ReservationQuestion();
    ipQuestion.questionType = ReservationQuestionType.IpAddress;
    ipQuestion.hiddenCategories = [];
    let ipQuestionAnswer: ReservationQuestionAnswer = new ReservationQuestionAnswer(ipQuestion, this.translate.currentLang);
    ipQuestionAnswer.answer = this.ipAddress;
    if(this.ticketReservation.additionalReservationData === undefined) {
      this.ticketReservation.additionalReservationData = [];
    }
    this.ticketReservation.additionalReservationData.push(ipQuestionAnswer);
    this.service.createReservation(this.ticketReservation).subscribe(
      res => {
        this.formSubmitted = false;
        this.ticketReservation.code = res;
        this.ticketReservation.additionalReservationData = this.ticketReservation.additionalReservationData
          .filter(x => x.questionType != ReservationQuestionType.IpAddress);
        this.ticketReservationService.updateTicketReservation(this.ticketReservation);
      },
      err => {
        this.formSubmitted = false;
        this.ticketReservation.additionalReservationData = this.ticketReservation.additionalReservationData
          .filter(x => x.questionType != ReservationQuestionType.IpAddress);
        this.translate.get(err.error).subscribe(res => this.toastr.error(res));
      }
    );
  }

  invalidReservation(): boolean {
    return this.formInvalid || !this.ticketReservation.categoryId || this.invalidReservationTime()
      || !this.termsChecked;
  }

  invalidReservationTime(): boolean {
    return !this.ticketReservation.reservationTime ||
      !(this.reservationInfo.availableTimes[this.ticketReservation.categoryId].availableReservations
        .find(x => this.timeService.sameTime(new Date(x.reservationTime), this.ticketReservation.reservationTime)));
  }

}
